import { initializeApp, type FirebaseApp } from 'firebase/app'
import { getAuth, type Auth } from 'firebase/auth'

let app: FirebaseApp | null = null
let auth: Auth | null = null

export async function initFirebase() {
  if (app && auth) return
  const res = await fetch('/firebaseConfig.json')
  const firebaseConfig = await res.json()
  app = initializeApp(firebaseConfig)
  auth = getAuth(app)
}

export function useFirebase() {
  if (!app || !auth) {
    throw new Error('Firebase no inicializado. initFirebase() debe ejecutarse primero.')
  }
  return { app, auth }
}